<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <h1>Посадочные страницы</h1>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn @click="$router.push({ name: 'landing-page-create'})">Создать</v-btn>
    </v-col>
    <v-col cols="12" sm="12">
      <v-data-table
              no-data-text="Нет тегов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="landingPages"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :options.sync="options"
              :footer-props="footerProps"
              :server-items-length="total"
              :items-per-page="30"
              :loading="loading"
              loading-text="Загрузка тегов... Подождите пожалуйста"
      >
        <template v-slot:item.type="{ item }">
          {{ item.type === 'home' ? 'Главная' : 'Категория'}}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'landing-page-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
  </v-row>
</template>

<script>
    // @ is an alias to /src


    import LandingPageService from "@/api/LandingPageService";

    export default {
        name: 'LandingPageIndex',
        components: {},
        data: () => ({
            overlay: false,
            search: '',
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            selected: [],
            landingPages: [],
            options: {},
            footerProps: {
                itemsPerPageText: 'Посадочных страниц на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
              itemsPerPageOptions: [15, 30]
            },
            total: 0,
            headers: [
                {
                    text: 'Название',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Тип',
                    value: 'type',
                    sortable: false
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},

            ],
        }),
        mounted() {
          this.getDataFromApi();
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
            getDataFromApi() {
                this.loading = true
                let params = {
                  page: this.options.page,
                }

                LandingPageService.list(params)
                    .then(response => {
                        this.landingPages = response.data.data
                        this.total = response.data.total
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
